"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
function _default(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}